<div class="progress-bar__timeline">
  <ng-content select="qe-progress-bar-step"></ng-content>
</div>
